const KebabIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="19"
      viewBox="0 0 6 19"
      fill="none"
    >
      <path
        d="M0.92334 9.50005C0.92334 10.6451 1.8552 11.577 3.00029 11.577C4.14538 11.577 5.07724 10.6451 5.07724 9.50005C5.07724 8.35495 4.14538 7.4231 3.00029 7.4231C1.8552 7.4231 0.92334 8.35495 0.92334 9.50005Z"
        fill="currentColor"
      />
      <path
        d="M0.92334 16.4231C0.92334 17.5682 1.8552 18.5001 3.00029 18.5001C4.14538 18.5001 5.07724 17.5682 5.07724 16.4231C5.07724 15.2781 4.14538 14.3462 3.00029 14.3462C1.8552 14.3462 0.92334 15.2781 0.92334 16.4231Z"
        fill="currentColor"
      />
      <path
        d="M0.92334 2.57683C0.92334 3.72192 1.8552 4.65378 3.00029 4.65378C4.14538 4.65378 5.07724 3.72192 5.07724 2.57683C5.07724 1.43174 4.14538 0.499878 3.00029 0.499878C1.8552 0.499878 0.92334 1.43174 0.92334 2.57683Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default KebabIcon;
